import BlockCareer from './block-career';

export default class BlockCareerDesktop extends BlockCareer {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/block-career/block-career.desktop.js